import { Radio, Select } from 'antd';
import { ChevronSVG } from 'components/iconsSVG/chevron';

import { useI18n } from 'context/i18n';
import { useValidate } from 'hooks';
import { IS_CAMPER } from './constants';

const { Option } = Select;

export const contactColumns = ({ countries }) => {
  const { t } = useI18n();
  const validate = useValidate();

  return {
    1: [
      {
        name: 'city',
        rules: validate('city'),
        floatLabel: t('contacto', 'poblacion', 'City'),
        required: true,
      },
      {
        name: 'shoeModel',
        rules: validate('requiredField'),
        floatLabel: t('contacto', 'modelo', 'Num. modelo'),
        required: true,
      },
      {
        name: 'shoeSize',
        rules: validate('requiredField'),
        floatLabel: t('contacto', 'talla', 'Size'),
        required: true,
      },
    ],
    4: [
      {
        name: 'postalCode',
        rules: validate('postalCode'),
        floatLabel: t('contacto', 'nuevo.codigo.postal', 'New postal code'),
        required: true,
      },

      {
        name: 'address',
        rules: validate('address'),
        floatLabel: t('contacto', 'nueva.direccion', 'New address'),
        required: true,
      },
      {
        name: 'city',
        rules: validate('city'),
        floatLabel: t('contacto', 'nueva.poblacion', 'New city'),
        required: true,
      },
    ],
    5: [
      {
        name: 'shoeSize',
        rules: validate('requiredField'),
        floatLabel: t('contacto', 'nueva.talla', 'New size'),
        required: true,
      },

      {
        name: 'shoeModel',
        rules: validate('requiredField'),
        floatLabel: t('contacto', 'modelo', 'Num. modelo'),
        required: true,
      },
    ],
    6: [
      {
        name: 'countryId',
        rules: validate('country'),
        floatLabel: t('contacto', 'pais', 'Country'),
        required: true,
        children: (
          <Select suffixIcon={<ChevronSVG />} tabIndex="11">
            {countries && (
              <>
                {countries.map((item, index) => (
                  <Option key={`title-${index}`} value={item.id}>
                    {item.name}
                  </Option>
                ))}
              </>
            )}
          </Select>
        ),
      },
    ],
    8: [
      {
        name: 'address',
        rules: validate('address'),
        floatLabel: t('contacto', 'direccion', 'Address'),
        required: true,
      },
      {
        name: 'city',
        rules: validate('city'),
        floatLabel: t('contacto', 'poblacion', 'City'),
        required: true,
      },
      {
        rules: validate('requiredOption'),
        required: true,
        name: 'newShop',
        children: (
          <Radio.Group>
            <Radio tabIndex="16" value={'new'}>
              {t('contacto', 'nueva.tienda', 'Nueva tienda')}
            </Radio>
            <br />
            <Radio tabIndex="17" value={'exist'}>
              {t('contacto', 'tienda.ya.existente', 'Tienda ya existente')}
            </Radio>
          </Radio.Group>
        ),
      },
      {
        name: 'postalCode',
        rules: validate('postalCode'),
        floatLabel: t('contacto', 'codigo.postal', 'Postal code'),
        required: true,
      },
      {
        name: 'empresa',
        rules: validate('requiredField'),
        floatLabel: t('contacto', 'empresa', 'Empresa'),
        required: true,
      },
    ],
    23: [
      {
        name: 'address',
        rules: validate('address'),
        floatLabel: t('contacto', 'direccion', 'Address'),
        required: true,
      },
      {
        name: 'city',
        rules: validate('city'),
        floatLabel: t('contacto', 'poblacion', 'City'),
        required: true,
      },

      {
        name: 'postalCode',
        rules: validate('postalCode'),
        floatLabel: t('contacto', 'codigo.postal', 'Postal code'),
        required: true,
      },
      {
        name: 'sku',
        rules: validate(IS_CAMPER ? 'sku' : 'unrequiredSku'),
        floatLabel: t('contacto', 'sku', '***SKU'),
        required: IS_CAMPER,
        tooltip: true,
        tooltipText: t(
          'contacto',
          'sku.explicacion',
          '*** Añade la referencia de tu zapatos. Podrás encontrarla en la parte inferior de la lengüeta. La referencia empieza con la letra K seguida de un código numérico, ej.: K800436-023.',
        ),
      },
    ],
  };
};
